import { useState } from "react";
import { BOOKS, getBook } from "../data/books";
import { MODELS } from "../data/models";
import { BookCover } from "../components/BookCover";
import { useApp } from "../context/AppContext";

export function BookDetailPage({ bookId }: { bookId: string }) {
  const { go } = useApp();
  const book = getBook(bookId) ?? BOOKS[0]!;
  const modelIdx = book.id === "lunar" ? 6 : book.id === "hanukkah" ? 4 : book.id === "diwali" ? 8 : 5;
  const sampleModel = MODELS[modelIdx];
  const [thumb, setThumb] = useState(0);
  return (
    <main className="detail">
      <div className="wrap">
        <div style={{ marginBottom: 28 }}>
          <a
            className="co-back"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              go({ name: "home" });
            }}
          >
            ← back to the collection
          </a>
        </div>
        <div className="detail-grid">
          <div>
            <div className="detail-cover-wrap">
              <div className="cover">
                <BookCover book={book} name={book.placeholderName} model={sampleModel} />
              </div>
            </div>
            <div className="detail-thumbs">
              {[0, 1, 2, 3].map((i) => (
                <button
                  key={i}
                  className={`detail-thumb ${i === thumb ? "active" : ""}`}
                  onClick={() => setThumb(i)}
                >
                  <div
                    className="mini"
                    style={{
                      background:
                        i === 0
                          ? book.cover.bg
                          : i === 1
                            ? book.cover.accent
                            : i === 2
                              ? "var(--paper)"
                              : book.cover.bg,
                      opacity: i === 2 ? 1 : 0.85,
                    }}
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="detail-info">
            <h1>
              {book.namePrefix && (
                <span style={{ display: "block", color: "var(--ink-soft)", fontSize: "0.42em", letterSpacing: "0.02em" }}>
                  {book.placeholderName + " " + book.namePrefix}
                </span>
              )}
              <span className="it">{book.titleSecond}</span>
            </h1>
            <p className="blurb">{book.blurb}</p>
            <div className="price-row">
              <span className="p">${book.price}.00</span>
              <span>USD · ships in 7–10 days</span>
            </div>
            <div className="specs">
              <div>
                <b>Softcover or Hardcover</b>sewn, matte laminate
              </div>
              <div>
                <b>32 pages</b>full-color, FSC paper
              </div>
              <div>
                <b>Ages 0–7</b>perfect for all ages
              </div>
              <div>
                <b>8 × 8 in</b>square format
              </div>
            </div>
            <button className="btn btn-rust big" onClick={() => go({ name: "personalize", bookId: book.id })}>
              Personalize my book <span className="arr">→</span>
            </button>
            <div className="preview-card">
              <h3>What you'll customize.</h3>
              <p>
                Your child's name appears on the cover and seven times inside. Their character — hair, skin tone —
                appears on every spread. You'll add a hand-written dedication and a signature on the very last page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
